import React from "react";
import ReactLoading from 'react-loading';
import { debounce } from "throttle-debounce";
import { AppRoutes } from "../../domain/navigation/AppRoutes";
import { isoDateString } from "../../helpers/dateHelpers";
import { DateNavigator, DateNavigatorType } from "../basic/DateNavigator";
import { BaseComponent } from "../core/BaseComponent";
import { AbsenceMonthTable } from "./AbsenceMonthTable";

interface AbsenceMonthProps {
    date: Date;
}
interface AbsenceMonthState {
    isLoading: boolean;
}

export class AbsenceMonth extends BaseComponent<AbsenceMonthProps, AbsenceMonthState> {
    debounceNavigate: debounce<(param: string) => void>;

    constructor(props: AbsenceMonthProps) {
        super(props);
        this.debounceNavigate = debounce(300, (path: string) => {
            this.navigateTo(path);
        });
    }

    navigateToDate(date: Date | null) {
        if (!date) {
            date = new Date();
        }
        this.debounceNavigate(`${AppRoutes.month}/${isoDateString(date)}`);
    }

    updateLoading(isLoading: boolean) {
        this.setStateWhenMounted({ isLoading });
    }

    render() {
        const date = this.props.date;
        return (<div>
            <div className="toolbar">
                <DateNavigator value={date} onChange={this.navigateToDate.bind(this)} type={DateNavigatorType.TypeMonth} />
                {this.state && this.state.isLoading ? <ReactLoading type="bars" color="rgba(219, 0, 47, 1)" className="react-loading" height="43px" width="43px" /> : null}
            </div>
            <AbsenceMonthTable date={date} onLoading={this.updateLoading.bind(this)} />
        </div>);
    }
}
